import React from "react";
import {Route, Switch as RouterSwitch, useRouteMatch} from "react-router-dom";
import {AdminsScreen} from "./screens/Admins.screen";
import {AdminScreen} from "./screens/Admin.screen";
import {ErrorAlert} from "../../sharedComponents/ErrorAlert";
import {clearAllAdminErrors} from "./redux/admins.slice";

export const AdminsFeature = () => {
    const {path} = useRouteMatch();
    return (
        <React.Fragment>
            <ErrorAlert
                selector={(state) => state.admins.errors.create}
                clearAction={clearAllAdminErrors}
            />
            <RouterSwitch>
                <Route path={`${path}/admin/:id`}>
                    <AdminScreen/>
                </Route>
                <Route path={path}>
                    <AdminsScreen/>
                </Route>
            </RouterSwitch>
        </React.Fragment>
    )
}
